module.exports = __webpack_public_path__ + "img/PXL_20230523_145102832.0c611988.jpg";